export const ADD_MESSAGE = 'app/FlashMessage/ADD_MESSAGE';
export const REMOVE_MESSAGE = 'app/FlashMessage/REMOVE_MESSAGE';
export const DEFAULT_VARIANT = 'info';
export const DEFAULT_ERROR_MESSAGE =
  'Oops, something went wrong. Please try again.';
/** Rejected by axios when there is no HTTP response (offline, timeout, connection reset, etc.). Do not change without updating callers that compare by reference. */
export const NETWORK_ERROR_MESSAGE =
  'Network error detected. Please try again.';
